import './SilverRateDropdown.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const SilverRateDropdownComponent = () => {
  const [prices, setPrices] = useState({ gold: null, silver: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const localResponse = await axios.get(
          'https://www.dhanapaljewellery.com/api/v1/rates',
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        const rates = localResponse.data;

        if (Array.isArray(rates) && rates.length > 0) {
          const latestRate = rates.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )[0];

          setPrices({
            gold: parseFloat(latestRate.goldRate),
            silver: parseFloat(latestRate.silverRate),
          });
        } else {
          throw new Error('No rates found in local database');
        }
      } catch (localErr) {
        console.warn('Local rate fetch failed:', localErr.message);

        try {
          const fallbackResponse = await axios.get(
            'https://jerwishtech.site/v1/api/account/todayrate'
          );

          setPrices({
            gold: parseFloat(fallbackResponse.data.Rate),
            silver: parseFloat(fallbackResponse.data.SILVERRATE),
          });
        } catch (fallbackErr) {
          console.error('Fallback API failed:', fallbackErr.message);
          setError('Failed to load rates');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  const silver22K = (prices.silver * 22 / 24).toFixed(2);
  const silver18K = (prices.silver * 18 / 24).toFixed(2);

  return (
    <div className="silver-dropdown-container">
      <div className="silver-dropdown">
        <button
          className="silver-dropdown-toggle dropdown-toggle"
          onClick={() => setIsOpen(!isOpen)}
          style={{
            background: 'linear-gradient(135deg, #C0C0C0, #A9A9A9)',
            transition: '0.3s',
          }}
        >
          <span>Silver 1G: ₹{prices.silver}</span>
        </button>

        {isOpen && (
          <ul className="silver-dropdown-menu">
            <li>Gold Rate: ₹{prices.gold}</li>
            <li>Silver 24K: ₹{prices.silver}</li>
            <li>Silver 22K: ₹{silver22K}</li>
            <li>Silver 18K: ₹{silver18K}</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default SilverRateDropdownComponent;
